"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnSortButton = void 0;
var react_1 = __importDefault(require("react"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var messages = __importStar(require("../translations"));
var css_1 = require("@emotion/css");
var ColumnSortButton = function (_a) {
    var column = _a.column;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    var currentSortDirection = column.getIsSorted();
    var nextSortDirectionLabel = formatMessage(messages, column.getFirstSortDir() === 'asc' ? 'sortByAscending' : 'sortByDescending', { column: column.id });
    if (currentSortDirection === 'asc') {
        nextSortDirectionLabel = formatMessage(messages, 'sortByDescending', { column: column.id });
    }
    else if (column.getIsSorted() === 'desc') {
        nextSortDirectionLabel = formatMessage(messages, 'sortByAscending', { column: column.id });
    }
    return !column.getIsSorted() ? (react_1.default.createElement(design_system_buttons_1.IconButton, { Icon: column.getFirstSortDir() === 'asc' ? design_system_foundations_1.IconArrowUp : design_system_foundations_1.IconArrowDown, size: "sm", "aria-label": nextSortDirectionLabel, className: (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ds-icon {\n          color: ", ";\n        }\n      "], ["\n        ds-icon {\n          color: ", ";\n        }\n      "])), design_system_foundations_1.theme.color.neutral60) })) : (react_1.default.createElement(design_system_buttons_1.IconButton, { variant: "primary", Icon: currentSortDirection === 'asc' ? design_system_foundations_1.IconArrowUp : design_system_foundations_1.IconArrowDown, size: "sm", "aria-label": nextSortDirectionLabel }));
};
exports.ColumnSortButton = ColumnSortButton;
var templateObject_1;
